import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { sortBy } from 'lodash';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { SCConfig } from '../../sc-config/constant/sc-config.constant';
import { ComponentSeed } from '../models/domain/ComponentSeed';
import { UrlResolverService } from './url/url-resolver.service';

@Injectable({
    providedIn: 'root'
})
export class ComponentService {
    private readonly urlResolver = inject(UrlResolverService);
    private getComponentSeedUrl = `${this.urlResolver.getPcxQueryUrl()}GetComponentSeed`;
    private insertOrUpdateComponentSeedUrl = `${this.urlResolver.getPcxCommandUrl()}InsertOrUpdateComponentSeed`;

    constructor(private http: HttpClient) {}

    getComponentSeed(itemIds: string[] = null): Observable<ComponentSeed[]> {
        return this.http
            .post(
                this.getComponentSeedUrl,
                {
                    ItemIds: itemIds,
                    Fields: ['ItemId', 'ComponentValue', 'ComponentKey', 'ComponentUsefulLife', 'Label']
                },
                SCConfig.HttpCommonOptions
            )
            .pipe(
                map(result => sortBy(result ? result['Data'] : [], 'ComponentValue')),
                shareReplay()
            );
    }

    insertOrUpdateComponentSeed(componentSeed: ComponentSeed) {
        return this.http.post(
            this.insertOrUpdateComponentSeedUrl,
            { ComponentSeed: componentSeed },
            SCConfig.HttpCommonOptions
        );
    }
}
